<template>
    <iframe ref="extral-page" :src="_refUrl" class="docframe width-p100" seamless :style="{ height: this.containerHeight }"></iframe>
</template>
<script>
import { mapGetters } from 'vuex'
// 用于自定义菜单节点
export default {
    name: `SectionLayoutExtralPage`,
    data() {
        return {
            title: `打开第三方页面`,
            refUrl: this.$route.query.source,
            token: this.$route.query.token,
            from: this.$route.query.from,
            unlogin_type: this.$route.query.unlogin_type,
            surgeryStatus: this.$route.query.surgeryStatus,
            extralPageUrlMode: this.$root.ExtralPageUrlMode,
            userInfo: {}
        }
    },
    created() {
        if (this.unlogin_type && this.unlogin_type == 1) {
            if (this.surgeryStatus) {
                this.refUrl = `${window.location.origin}#/unlogin_surgery?user=@userlogin&surgeryStatus=${this.surgeryStatus}&ACISForm=1`
            } else {
                this.refUrl = `${window.location.origin}#/unlogin_surgery?user=@userlogin&isAllStatus=1&ACISForm=1`
            }
        }
        if (this.active_ward && this.active_ward.code == `手术区`) {
            this.refUrl += `&active_ward=${this.active_ward.origion}`
        }
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
        }
        this.$store.dispatch(`ADD_CURRENTWORKER`)
    },
    computed: {
        ...mapGetters([`active_ward`, `screenHeight`, `currentWorker`]),
        containerHeight() {
            return `${this.screenHeight - 120}px`
        },
        _refUrl() {
            if (!this.refUrl) return null
            let refUrl = this.refUrl
            if (this.from != `google`) {
                refUrl = decodeURIComponent(refUrl)
            }
            let jmType = ``
            if (refUrl.indexOf(`base64_utf8`) != -1) {
                jmType = `|base64_utf8`
            }
            console.log(`this.currentWorker`)
            console.log(this.currentWorker)
            if (this.currentWorker) {
                _.each(this.currentWorker, (value, key) => {
                    let str = `@${key}` + jmType
                    var encode = eval(`/` + str + `/g`)
                    refUrl = refUrl.replace(encode, jmType == `` ? value : window.btoa(unescape(encodeURIComponent(value))))
                })

                if (refUrl.indexOf(`@userlogin`) != -1) {
                    let str = `@userlogin` + jmType
                    let encode = eval(`/` + str + `/g`)
                    let user = `${this.currentWorker.username}_${this.currentWorker.password}_layoutlogin`
                    refUrl = refUrl.replace(encode, jmType == `` ? user : window.btoa(unescape(encodeURIComponent(user))))
                }
            }
            if (this.extralPageUrlMode == `1` && !_.includes(refUrl, `doccenter`)) {
                if (refUrl.indexOf(`?`) > -1) {
                    let refstr = refUrl.split(`?`)
                    refUrl = refstr[0] + `?` + encodeURIComponent(refUrl.replace(refstr[0] + `?`, ``))
                }
            }

            console.log(refUrl)
            if (refUrl.indexOf(`@`) != -1) {
                return ``
            } else {
                return refUrl
            }
        }
    },
    methods: {
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.refUrl = newUrl.query.source
        }
    }
}
</script>

<style scoped>
.docframe {
    border: none;
    /* background: #c0c4cc; */
}
</style>



// WEBPACK FOOTER //
// src/components/SectionLayoutExtralPage.vue